module.exports = __webpack_public_path__ + "assets/img/guide-sm.ef37c188.jpg";